<template>
  <div>
    <Spinner v-if="loading" />
    <StaticDataTable v-if="!loading">
      <template #header>
        <th>Container</th>
        <th>Purchase Order Notes</th>
      </template>
      <template #body>
        <tr v-for="container in containerList" :key="container.id">
          <td>{{container.name}}</td>
          <td>
            <span v-if="!editing">{{getNotesForContainer(container)}}</span>
            <FormInputTextArea v-if="editing" :value="getNotesForContainer(container)" @input="updateNotesForContainer(container, $event)" :rows="4" />
          </td>
        </tr>
      </template>
    </StaticDataTable>
  </div>
</template>


<script>
export default {
  name: 'SupplierContainerList',
  props: {
    contactId: Number,
    editing: Boolean,
    supplierContainerListData: Array
  },
  data() {
    return {
      loading: false,
      containerList: [],
      valueList: _.clone(this.supplierContainerListData || [])
    }
  },
  watch: {
    supplierContainerListData: function(newVal) {
      this.valueList = _.clone(newVal || [])
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      this.loading = true

      this.$apiService.inventoryService.getStockContainerList()
      .then(response => {
        this.containerList = response.data.filter(container => container.isActive)
      })
      .catch(err => {
        console.error(err)
        this.displayNetworkError(err, 'Error loading container list')
      })
      .finally(() => {
        this.loading = false
      })
    },
    getNotesForContainer(container) {
      const entry = this.valueList.find(item => item.id === container.id)
      return entry ? entry.purchaseOrderNotes : ''
    },
    updateNotesForContainer(container, value) {
      let entry = this.valueList.find(item => item.id === container.id)
      if(entry) {
        entry.purchaseOrderNotes = value
      } else {
        this.valueList.push({
          id: container.id,
          purchaseOrderNotes: value
        })
      }

      this.$emit('update', this.valueList)
    }
  }
}
</script>